import React, { Component } from "react";

import { AnimationError } from "../../errors";
import "./Animations.styl";

class Animate extends Component {
    /*
        animation props: [
            fadeInUp
        ]
     */
    static CSSClass(classNames, state) {
        return `Animate-${classNames}-${state}`;
    }

    static timerId = 1;

    static DEFAULT = {
        DELAY: 100,
    };

    state = { in: this.props.in === true, firstState: true };
    timers = {};
    timer = null;

    mergeState = (newState) => this.setState(oldState => ({ ...oldState, ...newState, firstState: false }));
    delayedMergeState = (newState, delay) => {
        let timerId = Animate.timerId++;
        let timer = setTimeout(() => {
            this.mergeState(newState);
            delete this.timers[timerId];
        }, delay || Animate.DEFAULT.DELAY);
        this.timers[timerId] = timer;
    }

    componentDidMount() {
        if (this.props.in === undefined) this.delayedMergeState({ in: true }, this.inDelay());
    }
    
    componentDidUpdate() {
        if (this.props.in !== undefined && this.state.in !== this.props.in) {
            this.delayedMergeState({ in: this.props.in }, this.delay(this.props.in));
        }
    }

    componentWillUnmount() {
        for (let prop in this.timers) {
            clearTimeout(this.timers[prop]);
            delete this.timers[prop];
        }
    }

    inDelay = () => {
        return this.props.inDelay || this.props.delay || Animate.DEFAULT.DELAY;
    }

    outDelay = () => {
        return this.props.outDelay || this.props.delay || Animate.DEFAULT.DELAY;
    }

    delay = (_in) => {
        return _in ? this.inDelay() : this.outDelay();
    }

    getClassNames = (state) => {
        if (this.props.fadeInUp) {
            return Animate.CSSClass("fade-in-up", state);
        }
        if (this.props.fadeInRight) {
            return Animate.CSSClass("fade-in-right", state);
        }
        if (this.props.fadeInDown) {
            return Animate.CSSClass("fade-in-down", state);
        }
        if (this.props.fadeInLeft) {
            return Animate.CSSClass("fade-in-left", state);
        }
        throw new AnimationError("You must pass a valid animation prop.");
    }

    render() {
        let { timeout, in: _in, fadeInUp, fadeInRight, fadeInLeft, fadeInDown, delay, inDelay, outDelay, className, ...rest } = this.props;
        className = typeof className === "string" ? " " + className : "";
        return (
            <Transition in={this.state.in} timeout={timeout || 3000}>
            {
                (state) => (
                    <div className={this.getClassNames(state) + className} {...rest}>
                        {this.props.children}
                    </div>
                )
            }
            </Transition>
        );
    }
}

export default Animate;

class Transition extends Component {
    static STATE_NAMES = {
        ENTERED: "entered",
        EXITED: "exited",
    };

    state = { in: false, state: Transition.STATE_NAMES.EXITED };

    constructor(props) {
        super(props);
        if (typeof this.props.children !== "function") {
            throw new AnimationError("The children of <Transition> component must be a function.");
        }
    }

    mergeState = (newState) => this.setState(oldState => ({ ...oldState, ...newState }));

    getStateName = (_in) => {
        if (_in) return Transition.STATE_NAMES.ENTERED;
        return Transition.STATE_NAMES.EXITED;
    }

    componentDidUpdate() {
        if (typeof this.props.in === "boolean" && this.state.in !== this.props.in) this.mergeState({ in: this.props.in, state: this.getStateName(this.props.in) });
    }

    render() {
        return this.props.children(this.state.state);
    }
}
